import { socials } from './data';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="wrap footer__row">
        <p>
          <strong>Ayush Kumawat</strong>
          <span>AI & ML engineer · perception, language, agents</span>
        </p>
        <nav aria-label="Footer">
          {socials.map((item) => (
            <a
              key={item.label}
              href={item.href}
              {...(item.href.startsWith('http') ? { target: '_blank', rel: 'noreferrer noopener' } : {})}
            >
              {item.label}
            </a>
          ))}
          <a href="#top">Back to top</a>
        </nav>
      </div>
    </footer>
  );
}
